const TIME_ZONE = 'Europe/Copenhagen';

const dateTimeFormatter = new Intl.DateTimeFormat('da-DK', {
  timeZone: TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const dateFormatter = new Intl.DateTimeFormat('da-DK', {
  timeZone: TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const clockFormatter = new Intl.DateTimeFormat('da-DK', {
  timeZone: TIME_ZONE,
  weekday: 'short',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

function parts(formatter: Intl.DateTimeFormat, date: Date): Record<string, string> {
  const result: Record<string, string> = {};
  for (const part of formatter.formatToParts(date)) {
    result[part.type] = part.value;
  }
  return result;
}

function toDate(value: string | number | Date | null | undefined): Date | null {
  if (value === null || value === undefined || value === '') return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** dd-mm-yyyy HH:mm i Europe/Copenhagen. Tom streng ved manglende/ugyldig vaerdi. */
export function formatDateTime(value: string | number | Date | null | undefined): string {
  const date = toDate(value);
  if (!date) return '';
  const p = parts(dateTimeFormatter, date);
  return `${p.day}-${p.month}-${p.year} ${p.hour}:${p.minute}`;
}

/** dd-mm-yyyy i Europe/Copenhagen. */
export function formatDate(value: string | number | Date | null | undefined): string {
  const date = toDate(value);
  if (!date) return '';
  const p = parts(dateFormatter, date);
  return `${p.day}-${p.month}-${p.year}`;
}

/** Lang visning til topbaren, fx "man. 08-09-2026 14:32:07". */
export function formatClock(value: Date = new Date()): string {
  const p = parts(clockFormatter, value);
  return `${p.weekday} ${p.day}-${p.month}-${p.year} ${p.hour}:${p.minute}:${p.second}`;
}

/** ISO-dato (yyyy-mm-dd) til <input type="date">. */
export function toDateInputValue(value: string | number | Date | null | undefined): string {
  const date = toDate(value);
  if (!date) return '';
  const p = parts(dateFormatter, date);
  return `${p.year}-${p.month}-${p.day}`;
}
